import { render, staticRenderFns } from "./rightTableChart.vue?vue&type=template&id=8f0cf1c0&scoped=true"
import script from "./rightTableChart.vue?vue&type=script&lang=js"
export * from "./rightTableChart.vue?vue&type=script&lang=js"
import style0 from "./rightTableChart.vue?vue&type=style&index=0&id=8f0cf1c0&prod&lang=less&scoped=true"
import style1 from "./rightTableChart.vue?vue&type=style&index=1&id=8f0cf1c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0cf1c0",
  null
  
)

export default component.exports